import { Col } from 'react-bootstrap';
import { HeroText } from '../../atoms/heroText/HeroText';

export function EmptyStateCard() {
    return (
        <Col
            lg={5}
            xs={12}
        >
            <HeroText>Op dit moment is er geen specifieke informatie voor u te tonen.</HeroText>
        </Col>
    );
}
